import { render, staticRenderFns } from "./ConversationThread.vue?vue&type=template&id=93914956&scoped=true&"
import script from "./ConversationThread.vue?vue&type=script&lang=js&"
export * from "./ConversationThread.vue?vue&type=script&lang=js&"
import style0 from "./ConversationThread.vue?vue&type=style&index=0&id=93914956&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93914956",
  null
  
)

export default component.exports